import { Component, Input, OnInit } from '@angular/core'

import { AppComponent } from '../app.component'
import { XpService } from '../xp.service'
import { VismaService } from '../visma.service'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @Input() part: any

  url: string
  code: string
  created: boolean

  error = false
  modify = false
  loading = false
  validated = false
  submitted = false
  regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)

  model = <any>{ }
  constructor(private app: AppComponent, private xp: XpService, private visma: VismaService) { }

  ngOnInit() {
console.log('-- INIT login --')
    const url = new URL(window.location.href)
console.log(url)
    this.url = `${url.host}${url.pathname}`
    this.model.code = url.searchParams.get('i')
    this.model.part = this.part._id
    if (this.model.code) {
console.log(`-- check code -- ${this.url}`)
      const invite = JSON.parse(atob(this.model.code))
      this.modify = invite.modify
      if (invite.to) {
        this.model.user = invite.to
      }
console.log(invite)
    }
  }

  validate(mail: string) {
    this.validated = mail && mail.match(this.regexp) ? true : false
  }

  login() {
console.log('-- login function --')
    this.error = false
    this.loading = true
    this.submitted = true
    this.xp.login(this.part.service, this.model).subscribe((data) => {
      this.loading = false
      if (this.model.code) {
        this.created = true
      }
      else if (this.model.view === 'password') {
        this.created = true
      }
      else {
        window.location.href = this.part.destination
      }
    }, (error) => {
console.log('-- login failed --')
      this.error = true
      this.loading = false
      this.submitted = false
      console.log(`${error.status} ${error.statusText}`)
    })
  }
}
